import React from 'react'
import './Footer.scss'

export default function Footer() {
  return (
    <div id="main-footer-container">
      <div className="footer-text">Built by Brayden Werner</div>
    </div>
  )
}
